import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import { Actions } from 'src/store/app/actions';
import Box from '@mui/material/Box';
import {
  useAppVisibilityBtn,
  useIsMobile,
} from 'src/hooks';
import { getFilterInitialData } from 'src/store/requests/filter/selector';
import { getSelectedPlacement } from 'src/store/requests/type-of-property/selector';
import { requestSelectors } from 'src/store/requests/selectors';
import { LayoutApartmentItem } from 'src/components/LayoutApartmentItem';
import { FavIcon } from 'src/components/LayoutApartmentItem/components';
import { ButtonApp } from 'src/components/Button';
import { useTranslations } from 'src/hooks/translataions';
import { Actions as FloorsActions } from 'src/store/floors/actions';
import {
  getSelectedAppartment, getIsOpenAppartSidebar,
} from 'src/store/app/selectors';
import { locals } from 'src/constants/locals';
import useSwipe from 'src/hooks/useSwipeGesture';
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from './styles';

export const ApartmentSidebar: React.FC<{is2dView: boolean}> = ({ is2dView }) => {
  const mainColor = useSelector(requestSelectors.app.getMainColors);
  const styles = useStyles(mainColor);
  const dispatch = useDispatch();
  const { getTranslations } = useTranslations();
  const filteredData = useSelector(getFilterInitialData);
  const selectedApartment = useSelector(getSelectedAppartment);
  const typeOfProperty: any = useSelector(getSelectedPlacement);
  const isOpenApartSidebar = useSelector(getIsOpenAppartSidebar);
  const { isMobileScreen } = useIsMobile();
  const { filter_favorites } = useAppVisibilityBtn();
  const swipeHandlers = useSwipe({ onSwipedRight: () => handleCloseSidebar() });

  if (!selectedApartment || !filteredData || !filteredData[typeOfProperty]?.filter_all_data?.[selectedApartment]) {
    return null;
  }
  const { filter_all_data: filterAllData } = filteredData[typeOfProperty];

  const handleCloseSidebar = () => {
    dispatch(Actions.setIsOpenAppartSidebar(false));
    dispatch(FloorsActions.setSelectedApartmentId(undefined));
  };

  return (
    <div
      data-apartment-sidebar
      className={`${styles.sidebarWrapper} ${
        isOpenApartSidebar ? styles.wrapperOpen : styles.wrapperClose
      }`}
      {...swipeHandlers}
    >
      {is2dView && (
        <div className={styles.popoverContent}>
          <div className={styles.contentHoverGroup}>
            <Box
              className={styles.popoverContentActions}
            >
              <IconButton
                onClick={handleCloseSidebar}
                aria-label="close"
                size="large"
              >
                { !isMobileScreen && (
                  <ArrowForwardIcon fontSize="medium" />
                ) }
                { isMobileScreen && (
                  <CloseIcon fontSize="medium" />
                ) }
              </IconButton>
              { !isMobileScreen && filter_favorites && (
                <FavIcon
                  key={filterAllData[selectedApartment].id}
                  itemId={filterAllData[selectedApartment].id}
                />
              ) }
            </Box>
            <LayoutApartmentItem
              withSizeLimits={isMobileScreen}
              wrapperStyle={styles.wrapperLayoutStyles}
              property={filterAllData[selectedApartment]}
              isShowFavIcon={isMobileScreen && filter_favorites}
              onClosePopover={handleCloseSidebar}
            />
            <Link
              to={`/own/${filterAllData[selectedApartment].id}`}
              onClick={handleCloseSidebar}
            >
              <ButtonApp
                fullWidth
                text={getTranslations(locals.appTranslations.appMore)}
                variant="contained"
              />
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};
